export const V1_VEW = '/view/v1/list-view/find-by-code/'
export const V1_VEW_POST = '/view/v1/list-view/find-by-code'
export const V1_VEW_GET = '/view/v1/list-view/find-search/'
export const V1_VEW_HASHCODE = '/view/v1/list-view/encrypt'
export const V1_VEW_BY_ID = '/view/v1/list-view/find-by-id/'
export const AMIN_V1_VEW_POST = '/admin/v1/view/find-by-code'